// export default () => ({
// })

export default () => ({
    states: [],
    statesSelectable: [],
    statesPaginatedData: null,
    state: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})